import { createContext, useContext, useState, type ReactNode } from 'react';

interface NavigationContextType {
  page: number;
  setPage: (page: number) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  resetNavigation: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export function NavigationProvider({ children }: { children: ReactNode }) {
  const [page, setPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  const resetNavigation = () => {
    setPage(0);
    setSearchQuery('');
  };

  return (
    <NavigationContext.Provider
      value={{
        page,
        setPage,
        searchQuery,
        setSearchQuery,
        resetNavigation,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}
